module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _vm._v(" "), _c('em', [_vm._v("Remembering the Bones")]), _c('br'), _vm._v("© 2007 by Itani Writes Inc. All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("A Phyllis Bruce Book, published by HarperCollins Publishers Ltd.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("No part of this book may be used or reproduced in any manner"), _c('br'), _vm._v("whatsoever without the prior written permission of the publisher,"), _c('br'), _vm._v("except in the case of brief quotations embodied in reviews.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("HarperCollins books may be purchased for educational, business,"), _c('br'), _vm._v("or sales promotional use through our Special Markets Department.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("HarperCollins Publishers Ltd"), _c('br'), _vm._v("2 Bloor Street East, 20th Floor"), _c('br'), _vm._v("Toronto, Ontario, Canada"), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("M4W IA")]), _vm._v("8")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', [_vm._v("www.harpercollins.ca")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Library and Archives Canada Cataloguing in Publication")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Itani, Frances, 1942–"), _c('br'), _vm._v("Remembering the bones: a novel / Frances Itani.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("eBook ISBN-13: 978-1-5558-4812-5")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PS")]), _vm._v("8567."), _c('span', {
    staticClass: "small"
  }, [_vm._v("T")]), _vm._v("35"), _c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v("39 2007 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("C")]), _vm._v("813’.54 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("C")]), _vm._v("2007-902800-4")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("HC")]), _vm._v(" 9 8 7 6 5 4 3 2 1")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Printed and bound in the United States"), _c('br'), _vm._v("Designed by Sharon Kish")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aefbb34e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 72
// module chunks = 0